import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PersonContact } from '../_models/personContact';

@Injectable()
export class PersonContactService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getPersonContacts(): Observable<PersonContact[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/personContacts')
      .pipe(map((response) => response));
  }

  getPersonContact(id: number): Observable<PersonContact> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/personContacts/' + id)
      .pipe(map((response) => response));
  }

  savePersonContact(personContactItem): Observable<PersonContact> {
    const personContact = { ...personContactItem };
    delete personContact.lastUpdated;
    delete personContact.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    personContact.companyId = companySelected ? companySelected.id : null;

    if (personContact.user != null && personContact.user.id != null) {
      personContact.user = { id: personContact.user.id };
    }
    if (personContact.id) {
      return this.http
        .put<PersonContact>(
          this.apiBaseUrl + 'api/private/v1/personContacts/' + personContact.id,
          personContact
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<PersonContact>(this.apiBaseUrl + 'api/private/v1/personContacts/', personContact)
        .pipe(map((response) => response));
    }
  }

  deletePersonContact(id: number): Observable<PersonContact> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/personContacts/' + id).pipe(
      map((response) => {
        return { id } as PersonContact;
      })
    );
  }
}
